import { useEffect, useState } from "react";

const BASE_URL = "https://be-ofertas.utpl.edu.ec";

const DataFetcherOfertaLinea = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const programaMap = {
    maestria: "Maestría",
    especizacion: "Especialización",
    doctorado: "Doctorado",
  };

  const modalidadMap = {
    en_linea: "En línea",
    presencial: "Presencial",
    hibrida: "Híbrida",
  };

  const facultadMap = {
    facultad_de_ciencias_economicas_y_empresariales:
      "Ciencias Económicas y Empresariales",
    facultad_de_ciencias_exactas_y_naturales: "Ciencias Exactas y Naturales",
    facultad_de_ciencias_de_la_salud: "Ciencias de la Salud",
        facultad_de_ciencias_del_comportamiento: "Ciencias del Comportamiento",
    facultad_de_ciencias_sociales_educacion_y_humanidades:
      "Ciencias Sociales, Educación y Humanidades",
    facultad_de_ciencias_juridicias_y_politicas:
      "Ciencias Jurídicas y Políticas",
    facultad_de_ingenierias_y_arquitectura: "Ingenierías y Arquitectura",
    escuela_de_negocios: "UTPL Escuela de Negocios",
  };

  const getImageUrl = (node, included, fieldName) => {
    const mediaId = node.relationships?.[fieldName]?.data?.id;

    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--image" && item.id === mediaId,
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;

    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId,
    );

    return file?.attributes?.uri?.url || null;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        
    const baseUrl =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/carrera?" +
  "filter[field_modalidad]=en_linea" +
  "&sort=field_etiqueta_enlinea" +
  "&fields[node--carrera]=title,field_tipo_de_programa,field_facultad,field_modalidad,field_duracion,field_inicio_clases,field_campo_amplio,field_url_al_contenido,field_imagen_portada,field_etiqueta_enlinea" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri" +
  "&include=field_imagen_portada,field_imagen_portada.field_media_image";

        const urls = [
          `${baseUrl}`,
          `${baseUrl}&page[offset]=50&page[limit]=50`,
        ];

        const responses = await Promise.all(urls.map((url) => fetch(url)));
        const jsons = await Promise.all(responses.map((r) => r.json()));

        // Unir resultados de ambas consultas
        const allItems = jsons.flatMap((json) => json.data || []);
        const allIncluded = jsons.flatMap((json) => json.included || []);

        // Eliminar duplicados por ID
        const uniqueItems = [
          ...new Map(allItems.map((item) => [item.id, item])).values(),
        ];

        const transformed = uniqueItems.map((item) => {
          const attrs = item.attributes;

          const imagePath = getImageUrl(
            item,
            allIncluded,
            "field_imagen_portada",
          );

          // SOPORTE ROBUSTO PARA MODALIDADES (STRING O ARREGLO)
          let modalidadFormateada = attrs.field_modalidad;
          if (Array.isArray(attrs.field_modalidad)) {
            // Si viene un array ["en_linea", "presencial"], mapeamos cada elemento interno
            modalidadFormateada = attrs.field_modalidad.map(m => modalidadMap[m] || m);
          } else if (typeof attrs.field_modalidad === "string") {
            // Si viene un string simple "en_linea"
            modalidadFormateada = modalidadMap[attrs.field_modalidad] || attrs.field_modalidad;
          }

          return {
            id: item.id,
            title: attrs.title,
            field_programa:
              programaMap[attrs.field_tipo_de_programa] ||
              attrs.field_tipo_de_programa,
            field_facultad:
              facultadMap[attrs.field_facultad] || attrs.field_facultad,
            
            // Retorna la modalidad normalizada (sea string o array)
            field_modalidad: modalidadFormateada,
            field_etiqueta_enlinea: attrs.field_etiqueta_enlinea || "",
            field_duracion: attrs.field_duracion || "",
            field_inicio: attrs.field_inicio_clases || "",
            field_inicio_clases: attrs.field_inicio_clases || "",
            field_campo_amplio: attrs.field_campo_amplio || "",
            field_url: attrs.field_url_al_contenido || "",
            field_imagen_portada: imagePath
              ? BASE_URL + imagePath
              : "https://via.placeholder.com/600x400",
          };
        });

        setData(transformed);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        return setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error}</p>;

  return children(data);
};

export default DataFetcherOfertaLinea;